import type { CreatureDisplayNameInput } from '../types';

/** Select the finalized item name with PHP null-coalescing precedence. */
export function compileCreatureDisplayName(input: CreatureDisplayNameInput): string {
    return input.playerName ?? input.encounterCreatureName ?? input.itemName ?? 'N/A';
}
